export const APP_NAME = 'ImageBank';
export const API_SERVER = 'http://localhost:8091';
export const API_PATH = '/api/';
export const API_VERSION = '1.0';
export const GA_TRACKING_CODE = 'UA-asdasdasd-1';

export const AUTH_SERVER = 'http://cms.scroll.team';
export const AUTH_API_VERSION = '1.0';

const AUTH_API_BASE = AUTH_SERVER + '/api/' + AUTH_API_VERSION;

export function getAuthURL(url) {
  return AUTH_API_BASE + url;
}

export const Credential = 'same-origin';
export const LoginURL = getAuthURL('/auth/login');
export const LogoutURL = getAuthURL('/auth/logout');
export const SESSION_COOKIE_NAME = '__s';
export const USERINFO_COOKIE_NAME = 'userinfo';
export const SESSION_COOKIE_DOMAIN = 'localhost';

export const BASE_PATH = API_SERVER + API_PATH + API_VERSION;



/** WEBPACK FOOTER **
 ** ./configs/scroll/config.dev.js
 **/